export default __webpack_public_path__ + "assets/images/aistudio/empty_state/a6c1b480de829e9fb313abb188c3211f.png";